export const defaultColumns = [
  { label: 'Número de protocolo', value: 'protocol_number' },
  { label: 'Status', value: 'status' },
  { label: 'Equipamento', value: 'equipment' },
  { label: 'Autor', value: 'author' },
  { label: 'Tipo de solicitação', value: 'kind' },
  { label: 'Descrição', value: 'observations' },
  { label: 'Programa de manutenção', value: 'maintenance_program' },
  { label: 'Regra atingida', value: 'rule_reached' },
  { label: 'Dt. e Hr.', value: 'created_at' },
  { label: 'Ação', value: 'action', className: 'w-9' },
]
